<template>
  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" stroke="#2990FF" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.58301 15.5833L15.583 1.58334" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: "thin-line-icon",
};
</script>
